import { Link } from '@tanstack/react-router';
import { Compass } from 'lucide-react';

import { t } from '@/shared/i18n';
import { Button } from '@/shared/ui/Button';
import { EmptyState } from '@/shared/ui/EmptyState';

import styles from './NotFoundPage.module.scss';

/**
 * Страница «не найдено».
 *
 * Сюда же ведёт адрес с неизвестным окружением: тихо подменить его боевым
 * значило бы дать править прод человеку, который думает, что он на деве.
 */
export function NotFoundPage() {
  return (
    <div className={styles['page']}>
      <EmptyState
        icon={<Compass />}
        title={t.notFound.title}
        description={t.notFound.text}
        action={
          <Button variant="outline" tone="neutral" asChild>
            <Link to="/sites">{t.notFound.back}</Link>
          </Button>
        }
      />
    </div>
  );
}
